import newsDetails from 'components/news/newsDetails';

export default {
	'components.base.NewsDetails': {
		factory: newsDetails,
		deps: [{ $ref: 'components.StateManager' }, { $ref: 'services.newsService' }],
	},
};
